module.exports = __webpack_public_path__ + "media/components/lesson1/common/statics/workSpace-0d8765d60f7bbe366d85ec542e562492.gif";